// Import package components
import moment from "moment";
import { useContext, useEffect, useMemo } from "react";

import { AppContexts } from "../../providers";

const TodaysBookings = () => {
  const reservationContext = useContext(AppContexts.ReservationsContext);

  useEffect(() => {
    reservationContext.getTodaysBookings();
  }, []);

  console.log(reservationContext.todaysBookings);

  return (
    <table
      className="uk-table uk-table-striped"
      style={{ width: "1024px", margin: "20px 60px" }}
    >
      <caption></caption>
      <thead>
        <tr>
          <th>Reservation ID</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Check In</th>
          <th>Check Out</th>
          <th>Property</th>
          <th>Lock Box Code</th>
        </tr>
      </thead>
      <tbody>
        {(reservationContext.todaysBookings || []).map((l) => {
          return (
            <tr>
              <td>{l.native_id}</td>
              <td>{l.first_name}</td>
              <td>{l.last_name}</td>
              <td>{moment(l.check_in).format("MM/DD/YYYY")}</td>
              <td>{moment(l.check_out).format("MM/DD/YYYY")}</td>
              <td>{l.pms_id}</td>
              <td>{l.lockbox_code}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default TodaysBookings;
